import $ from 'jquery';
import Form from './form-errors.js';
import Notification from './notification.js';


class FormSubmitter {

    constructor(options) {

        this.opt = {};

        // Destructure Options, setting defaults
        let {
            formSelector = '#form',
            triggerSelector = '#form [type="submit"]',
            action = $(formSelector).attr('action'),
            csrf = $('meta[name="csrf-token"]').attr('content'),
            type = 'post',
            forceNoData = false
        } = options;

        // set the options
        this.opt.formSelector = formSelector;
        this.opt.triggerSelector = triggerSelector;
        this.opt.form = $(formSelector);
        this.opt.action = action;
        this.opt.trigger = $(triggerSelector);
        this.opt.csrfStr = csrf;
        this.opt.type = type;
        this.opt.forceNoData = forceNoData;
        // submit action

        $('body').on('click', this.opt.triggerSelector, this.submitAction.bind(this));
    }

    submitAction(e) {

        // set form data
        this.opt.formData = new FormData(this.opt.form[0]);

        // prevent submit
        e.preventDefault();

        // get response from server-side validation services
        $.ajax({
            headers: {
                'X-CSRF-TOKEN': this.opt.csrfStr
            },
            type: this.opt.type,
            url: this.opt.action,
            data: (this.opt.forceNoData) ? false : this.opt.formData,
            dataType: 'json',
            cache: false,
            processData: false,
            contentType: false,
            success: function(data) {
              console.log('hai avuto successo');
              console.log(data);
                this.successHandler(data);
            }.bind(this),
            error: function(data){
                this.errorHandler(data);
            }.bind(this)
        }); //ajax

    }

    errorHandler(data){
        // detect error messages
        let errorSet = data.responseJSON.errors;
      console.log(data.responseJSON);

        // notify the errors in form or in field
        for (let k in errorSet) {
            if (k === '_form'){
                let m = new Notification(d[k], { 'type': 'danger' });
            } else {
                Form.addError(this.opt.formSelector + ' [name="'+k+'"]', errorSet[k]);
            }
        }
    }


    successHandler(data) {
      console.log('hai avuto successo');
        if (data.status === 'OK'){

            // redirect to the url given by server-side logics
            let url = data.redirect;
            window.location.replace(url);
        }
    }

}


export default FormSubmitter;


// WEBPACK FOOTER //
// ./src/js/inc/form-submitter.js